import {
  cartSelector,
  controlMenuQuantity,
  deleteMenu,
  initCart,
  setCartMenu as _setCartMenu,
} from '@stores/cart';
import { ICartMenus } from 'interfaces/cart';
import { IYogiyoStore } from 'interfaces/store';
import { useDispatch, useSelector } from 'react-redux';

export default function useCart() {
  const cart = useSelector(cartSelector);
  const dispatch = useDispatch();

  const calculateMenuCount = () => {
    return cart.menus ? cart.menus.length : 0;
  };

  const setCartMenu = (menuInfo: {
    restaurant: IYogiyoStore;
    menu: ICartMenus;
  }) => {
    dispatch(_setCartMenu(menuInfo));
  };

  const handleDeleteMenu = (menuId: number) => {
    dispatch(deleteMenu(menuId));
  };

  const handleMenuQuantity = (id: number, quantity: number) => {
    dispatch(controlMenuQuantity({ id, quantity }));
  };

  const handleInitCart = () => {
    dispatch(initCart({}));
  };

  const getTotalMarginPrice = () => {
    if (!cart || !cart.menus) return 0;
    const menuPrice = cart.menus.reduce((acc, menu) => {
      let menuTotal = +menu.finalPrice - (menu.isHotdeal ? 1000 : 0);

      menu.options.forEach((option) => {
        menuTotal += +option.marginPrice;
      });

      menuTotal *= menu.quantity;

      return (acc += menuTotal);
    }, 0);

    return menuPrice;
  };
  return {
    cart,
    calculateMenuCount,
    setCartMenu,
    deleteMenu: handleDeleteMenu,
    controlMenuQuantity: handleMenuQuantity,
    initCart: handleInitCart,
    getTotalMarginPrice,
  };
}
